import React from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import { ReactComponent as Logo } from '../../../assets/images/logo/logo-light.svg';
import ScrollIndicator from '../../ScrollIndicator';

import './style.scss';

const Outro = ({ title, body, backgroundImage, onStart = null }) => {
  return (
    <div className="AnnualReport__outro">
      <div className="AnnualReport__outro__wrapper">
        <div className="AnnualReport__outro__content">
          <Logo width={200} />
          <h1>{ title }</h1>
          <p>{ body }</p>
          { onStart && <ScrollIndicator onClick={onStart} /> }
        </div>
        <div className="AnnualReport__outro__content__image">
          <Image src={backgroundImage} />
        </div>
      </div>
    </div>
  );
};

export default Outro;
